(function (angular) {
    'use strict';

    angular.module('chat2')
        /**
         * Directive to scroll to bottom when content changes.
         * Apply to a list that has a fixed height and overflow auto style.
         */
        .directive('autoScroll', ["$window", "$timeout", function ($window, $timeout) {
            return {
                link: function (scope, element, attrs) {

                    // record the time when the view initialised
                    // a conversation containing a lot of images needs to
                    // ignore the gap logic for a period of time
                    var timestamp = new Date();
                    // for the first 5 seconds, always scroll to bottom when images load ...
                    var overrideGrace = 5000;

                    function _scroll(){
                        $timeout(()=>{
                            element[0].scrollTop = element[0].scrollHeight;
                        },100);                            
                    }

                    function scroll(trigger) {

                        var now = new Date();
                        var difference = now - timestamp;
                        var override = difference < overrideGrace;

                        // console.log("scrolling to bottom after " + trigger);

                        var bottomGapPx = element[0].scrollHeight - element[0].scrollTop - element[0].clientHeight;

                        // console.log("bottomGapPx: ", bottomGapPx);

                        if (bottomGapPx <= element[0].clientHeight * 2 || override) {
                            // console.log("gap inside 2 pages, scrolling");
                            _scroll();
                        }
                    }

                    // something has resized (child iframe)
                    angular.element($window).on('resize', function () {
                        scroll("resize");
                    });

                    // an image has loaded (chat bubble will have resized)
                    scope.$on("image.load", function (event, info) {
                        scroll("image.load");
                    });

                    // a new message has been rendered into the conversation
                    scope.$on("newMessageRendered", function (event, id) {
                        // console.log("got newMessageRendered: ", id);
                        scroll("newMessageRendered");
                    });

                    // When view initially loads, we ALWAYS want to scroll to the bottom
                    _scroll();

                },
            }
        }])
        .directive('onLoad', ['$rootScope', function ($rootScope) {
            return {
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.on('load', function (event) {
                        // console.log("onLoad()", event);
                        $rootScope.$broadcast('image.load', event);
                    });
                }
            }
        }])
        .directive('setChatHeight', ['$window', function ($window) {
            return {
                link: function (scope, element, attrs) {

                    var is1280 = false;

                    function matchMediaHandler(x) {
                        // console.log("(max-width: 1280px) : " + x.matches);
                        is1280 = x.matches;
                        setHeight();
                    }

                    var x = $window.matchMedia("(max-width: 1280px)");
                    is1280 = x.matches;

                    x.addListener(matchMediaHandler) // Attach listener function on state changes

                    function setHeight() {

                        var height = $window.innerHeight;

                        // want to conditionally add 50 px if we are in the 1280 media query 
                        var h = height - (attrs.usedHeight || 0);
                        if (is1280) {
                            h += 65;
                        }
                        element.css('height', h + 'px');
                    }

                    angular.element($window).on('resize', function () {
                        setHeight();
                    });

                    setHeight();
                }
            };
        }]);
})(window.angular);
